export const tagTypes = {
    favourite: 'favourite',
    prescription: 'prescription',
    patient: 'patient',
    appointments: 'appointments',
    doctor: 'doctor',
    reviews: 'reviews',
    timeSlot: 'timeSlot',
    blogs: 'blogs',
    medicine: 'medicine',
    interestedDoctor: 'interestedDoctor',
    contact: 'contact'
}

export const tagTypeList = [
    tagTypes.favourite,
    tagTypes.prescription,
    tagTypes.patient,
    tagTypes.appointments,
    tagTypes.doctor,
    tagTypes.reviews,
    tagTypes.timeSlot,
    tagTypes.blogs,
    tagTypes.reports,
    tagTypes.medicine,
    tagTypes.interestedDoctor,
    tagTypes.contact,
]